import React, { Component } from 'react';
import { connect } from 'react-redux';

import Input from './Input';
import Button from 'components/Button';

import PlusIcon from '../../assets/icons/plus';
import RemoveIcon from '../../assets/icons/minus-circle';



import { firebaseConnect, helpers } from 'react-redux-firebase';
const { isLoaded, dataToJS } = helpers;

import { keyedObjToArr, formatAddress } from '../util';

class UserListPanel extends Component{

	constructor(props) {
		super(props);
		this.state = {
			user : ''
		};
	}

	addUser(option) {
		if(!option) {
			return;
		}
		this.props.addUserToCustomer(option.value, this.props.customer);
		this.setState({
			user : ''
		});
	}

	removeUser(userId) {
		this.props.removeUserFromCustomer(userId, this.props.customer);
	}

	selectUser(user) {
		this.setState({
			user : user
		});
	}

	render (){
			if(!isLoaded(this.props.users)) {
				return false;
			}

			var customerUsers = this.props.customer.users ? keyedObjToArr(this.props.customer.users).map( (user)=> {
				return this.props.users[user.id];
			}).filter(function(user){ return user !== undefined; }) : [];

			var userOptions = keyedObjToArr(this.props.users)
			.filter( (user)=> {
				if(this.props.customer.users) {
					return user.role !== 'admin' && !this.props.customer.users[user.id];
				} else {
					return user.role !== 'admin';
				}
			}).map( (user)=> {
				return {
					label : user.email,
					value : user.id
				};
			});

			return (
				<div>
					{/*list of users in customer*/}
					<div className="ui-list tight">
						<div className="header-container">
							<div className="list-row header" key="header">
								<div className="list-cell"><span className="data">Email</span></div>
								<div className="list-cell"><span className="data">Name</span></div>
								<div className="list-cell"><span className="data">Role</span></div>
								<div className="list-cell no-grow no-left-pad"><span className="data"></span></div>
							</div>
						</div>
					{ customerUsers.map( (user, index)=> {
						return(
							<div key={index} className="list-row">
								<div className="list-cell">{user.email}</div>
								<div className="list-cell">{user.name}</div>
								<div className="list-cell">{user.role}</div>
								<div className="list-cell no-grow no-left-pad">
									<Button
										tooltipText="Remove"
										tooltipPosition="left"
										icon={RemoveIcon}
										buttonClass="circle transparent tiny hover-red"
										onClick={this.removeUser.bind(this, user.id)}
									/>
								</div>
							</div>
						);
					})}
					</div>
					{/*typeahead to add users*/}
					<div className="">
						<Input
							type="typeahead"
							fixedBtn="Add User"
							btnAction={this.addUser.bind(this)}
							fixedBtnIcon={PlusIcon}
							placeholder="User"
							name="user"
							value={this.state.user}
							onChange={this.selectUser.bind(this)}
							options={userOptions}
						/>
					</div>
				</div>
			);
	}
}


const fbWrappedComponent = firebaseConnect([
	'/users',
])(UserListPanel);

export default connect(
({ firebase }) => ({
		users: dataToJS(firebase, 'users')
	}),
	null
)(fbWrappedComponent);




// WEBPACK FOOTER //
// ./js/components/UserListPanel.js